// extracted by mini-css-extract-plugin
export default {"mainLayout":"MainLayout_mainLayout__0YQO+"};